wbApp.filter('invoiceValid', ['$translate', function ($translate) {
    return function (input) {

        if (input === null || input === undefined) {
            return '';
        }

        return input
            ? $translate.instant('TXT_INVOICE_VALID')
            : $translate.instant('TXT_INVOICE_CANCEL');
        }
}]);